import Request from '../../services/Request';
import ResponseChecker from '../../services/ResponseChecker';
import NotiMessage from '../../services/NotiMessage';

const notiMessage = new NotiMessage('success');

// URL //
const eachUrl = 'township/getEach?';
const allUrl = 'township/get?';
const storeUrl = 'township/store';
const updateUrl = 'township/update?';
const deleteUrl = 'township/delete?';

const state = {
  townships: [],
  township: {},
  initalOpt: [{ id: 1, name: "No", }, { id: 2, name: "Yes", }],
  initialPj: [{ id: 1, name: "No", }, { id: 2, name: "Yes", }],
};
const getters = {};
const mutations = {
  SET_TOWNSHIPS(state, payload) {
    state.townships = payload.data.data
  },
  SET_TOWNSHIP(state, payload) {
    state.township = payload.data.data
  },
  ADD_TOWNSHIP(state, payload) {
    state.townships.push(payload.data.data)
  },
  REMOVE_TOWNSHIP(state, payload) {
    const townships = state.townships.filter((item) => item.id != payload.id)
    state.townships = [...townships]
  }
};

const actions = {
  async getTownships({ commit }) {
    const response = await Request.get_data(allUrl)
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIPS", response);
  },
  async getTownshipByTwnGpId({ commit }, id) {
    const response = await Request.get_data(allUrl, { township_group_id: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIPS", response);
  },
  async getTownshipByRgnId({ commit }, id) {
    const response = await Request.get_data(allUrl, { region_id: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIPS", response);
  },
  async getTownship({ commit }, id) {
    const response = await Request.get_data(eachUrl, { column: 'id', value: id })
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess())
      commit("SET_TOWNSHIP", response);
  },
  async createTownship({ commit }, payload) {
    const response = await Request.post_data(storeUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("ADD_TOWNSHIP", response);
      notiMessage.displayNotiMsg('Saved Success')
      return true
    }
    return false;
  },
  async updateTownship(context, payload) {
    const response = await Request.post_data(updateUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      notiMessage.displayNotiMsg('Updated Success')
      return true
    }
    return false;
  },
  async deleteTownship({ commit }, payload) {
    const response = await Request.post_data(deleteUrl, payload);
    const responseChecker = new ResponseChecker(response);
    responseChecker.checkResponse();
    if (responseChecker.isResponseStatusSuccess()) {
      commit("REMOVE_TOWNSHIP", payload);
      notiMessage.displayNotiMsg('Deleted Success')
      return true
    }
    return false;
  },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
